import { render, staticRenderFns } from "./KioskMode.vue?vue&type=template&id=79a0fefd&scoped=true"
import script from "./KioskMode.vue?vue&type=script&lang=ts"
export * from "./KioskMode.vue?vue&type=script&lang=ts"
import style0 from "./KioskMode.vue?vue&type=style&index=0&id=79a0fefd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a0fefd",
  null
  
)

export default component.exports